import { afterLogin } from '../premium/billingIntent';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import loginLogoIcon from "../Assets/carrerup_profile_NoBg.png";
import "./LoginTransition.css";

const TRANSITION_DURATION = 3200;

export default function LoginTransition() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [progress, setProgress] = useState(0);
  const isRtl = i18n.dir() === "rtl";

  useEffect(() => {
    const startedAt = performance.now();
    let animationFrame;

    const updateProgress = (now) => {
      const nextProgress = Math.min(
        100,
        Math.round(((now - startedAt) / TRANSITION_DURATION) * 100)
      );

      setProgress(nextProgress);

      if (nextProgress < 100) {
        animationFrame = requestAnimationFrame(updateProgress);
      }
    };

    animationFrame = requestAnimationFrame(updateProgress);

    const redirectTimer = window.setTimeout(() => {
      navigate(afterLogin(), { replace: true });
    }, TRANSITION_DURATION + 180);

    return () => {
      cancelAnimationFrame(animationFrame);
      window.clearTimeout(redirectTimer);
    };
  }, [navigate]);

  return (
    <main
      className="login-transition"
      aria-label={t("loginTransition.ariaLabel")}
      dir={isRtl ? "rtl" : "ltr"}
    >
      <div className="transition-grid" />
      <div className="transition-glow transition-glow-one" />
      <div className="transition-glow transition-glow-two" />

      <section className="transition-stage">
        <div className="transition-orbit" aria-hidden="true">
          <span className="orbit-ring orbit-ring-one" />
          <span className="orbit-ring orbit-ring-two" />
          <span className="orbit-ring orbit-ring-three" />
          <span className="orbit-pulse" />
          <span className="orbit-satellite satellite-one" />
          <span className="orbit-satellite satellite-two" />
          <span className="orbit-satellite satellite-three" />
          <div className="transition-core">
            <span className="core-scan" />
            <img src={loginLogoIcon} alt="" />
          </div>
        </div>

        <div className="transition-copy">
          <span className="transition-eyebrow">CARRERUP NETWORK</span>
          <h1>{t("loginTransition.title")}</h1>
          <p>{t("loginTransition.subtitle")}</p>
        </div>

        <div className="transition-progress" aria-label={`Chargement ${progress}%`}>
          <div className="transition-progress-track">
            <span style={{ width: `${progress}%` }} />
          </div>
          <div className="transition-progress-meta">
            <span>{t("loginTransition.loading")}</span>
            <strong>{progress}%</strong>
          </div>
        </div>
      </section>
    </main>
  );
}
